import { useDashboardControls } from 'contexts/Dashboard/useDashboardControls';
import DashboardWidgetsWrapper from 'components/Dashboard/WidgetWrapper';
import { memo } from 'react';
import { WidgetConfig } from 'components/Dashboard/types';
import { HRSpeedingWidgetsEnum } from './utils';
import HRSpeedingWidget from './widgets/HRSpeedingWidget';

const widgetConfig: WidgetConfig<HRSpeedingWidgetsEnum>[] = [
  {
    widgetType: HRSpeedingWidgetsEnum.SpeedingReport,
    component: memo(HRSpeedingWidget),
  },
];

const HRSpeedingDashboard = () => {
  const {
    dashboardState: { widgets },
  } = useDashboardControls();

  const getIsActive = (widgetType: HRSpeedingWidgetsEnum) => {
    return widgets.some(
      (w) => w.identifier === widgetType && w.active === true
    );
  };

  return (
    <DashboardWidgetsWrapper>
      {widgetConfig.map(
        ({ widgetType, component: Component }) =>
          getIsActive(widgetType) && <Component key={widgetType} />
      )}
    </DashboardWidgetsWrapper>
  );
};

export default HRSpeedingDashboard;
